import React from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Autoplay } from 'swiper';
import Placeholder from "../Placeholders/Placeholder";

/**
 * @author Anurag Chauhan 
 * @date 04/09/2025
 * @task #162921 urgent-website-update
 * @change - To show the Header Text Links from the API as per the client request in the header top content @task #162921 urgent-website-update
 * @description Header Top Content Component
 */

function HeaderTopContent({ headerContent, isLoading }) {
  return (
    <div className="header-top-content-wrapper">
      {isLoading ? <Placeholder variant="text" width={"100%"} className="mx-auto" /> : (
      <Swiper
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        styles={{padding:"0px !important"}}
        autoplay={{
          delay: 3600,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="header-top-content-swiper"
      >
        {headerContent?.map((item, index) => (
          <SwiperSlide key={index}>
            <p> <Link to={item.link}>{item.text}</Link></p>
          </SwiperSlide>
        ))}
      </Swiper>
      )}
    </div>
  );
}

export default HeaderTopContent;